import { useAtomValue } from 'jotai';

import { usePayments } from '../../../context/PaymentsProvider';
import { isStripeLoadedAtom } from '../../../context/StripeProviderStore';
import StripeNotLoadedError from '../../StripeNotLoadedError/StripeNotLoadedError';

import PayNowQRDescription from './PayNowQRDescription';

const PayNowQR = () => {
  const { payNowQr, country } = usePayments();
  const stripeIsLoaded = useAtomValue(isStripeLoadedAtom);

  if (!stripeIsLoaded) {
    return <StripeNotLoadedError />;
  }

  if (!payNowQr) {
    return <></>;
  }

  if (country !== 'SG') {
    return <></>;
  }

  return <PayNowQRDescription />;
};

export default PayNowQR;
